var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    style: {
      verticalAlign: "middle",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.76 69.12l-47.78666667 47.78666667L255.14666667 302.93333333l-72.53333334 72.53333334H375.46666667V182.61333333l-71.68 71.68zM768.85333333 302.93333333l185.17333334-186.02666666-47.78666667-47.78666667-186.02666667 185.17333333-71.68-71.68V375.46666667h192.85333334zM254.29333333 720.21333333L73.38666667 901.97333333l47.78666666 52.90666667L302.93333333 768.85333333l72.53333334 72.53333334V648.53333333H182.61333333zM841.38666667 648.53333333H648.53333333v192.85333334l72.53333334-72.53333334 181.76 186.02666667 47.78666666-52.90666667-180.90666666-181.76z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreen);
export default __webpack_public_path__ + "static/media/exit-fullscreen.d10801d066d57af4044fb3afefd6d4ec.svg";
export { ForwardRef as ReactComponent };